class SubsidyModel {
    selected = 'active'
    active
    custom
    no
    titleNoSubsidy

    constructor({ activeSubsidy, titleNoSubsidy = 'No subsidy' } = {})
    {
        let customAmount = 0;
        if (activeSubsidy.amount) {
            customAmount = parseFloat(activeSubsidy.amount)
        }
        this.selected = 'active'
        this.active = activeSubsidy
        this.custom = {
            title: activeSubsidy.title,
            amount: customAmount
        }
        this.no = {
            title: titleNoSubsidy,
        }
        this.titleNoSubsidy = titleNoSubsidy
    }

    isExists({ installationSize = null } = {})
    {
        return this.getSubsidyAmount({ installationSize: installationSize }) > 0
    }

    getSelectedSubsidy({ installationSize = null } = {})
    {
        let amount = this.getSubsidyAmount({ installationSize: installationSize})

        return {
            exists: amount > 0,
            title: this.getSubsidyTitle(),
            amount: amount
        }
    }

    getSubsidyTitle()
    {
        if (this.selected === 'active') {
            return this.active.title
        } else if (this.selected === 'custom') {
            return this.custom.title
        }

        return this.titleNoSubsidy
    }

    getSubsidyAmount({ installationSize=null } = {})
    {

        if (this.selected === 'active') {
            if (this.active.key === 'premie') {
                return this.getPremieSubsidyAmount({ installationSize: installationSize })
            } else if (this.active.key === 'moj_prad') {
                return this.getMojPradSubsidyAmount()
            } else if (this.active.key === 'moja_hp') {
                return this.getMojaPompaCieplaAmount()
            }

        } else if (this.selected === 'custom') {
            return this.getCustomSubsidyAmount()
        }

        return 0
    }

    getCustomSubsidyAmount()
    {
        return this.custom.amount
    }

    getMojPradSubsidyAmount()
    {
        if (this.active.key !== 'moj_prad') { return 0 }

        return this.active.amount
    }

    getMojaPompaCieplaAmount()
    {
        if (this.active.key !== 'moja_hp') { return 0 }

        return this.active.amount
    }

    getPremieSubsidyAmount({ installationSize })
    {
        if (this.active.key !== 'premie') { return 0 }

        if (installationSize <= 0) { return 0 }

        const sizes = Object.assign({}, this.active.sizes)

        let prevSize = 0;
        let subsidyAmount = 0;
        Object.keys(sizes).forEach(size => {
            let price = sizes[size]
            if (installationSize >= size) {
                subsidyAmount += (size - prevSize) * price
            } else {
                subsidyAmount += (installationSize - prevSize) * price
            }
            prevSize = size
        });

        return subsidyAmount
    }

}

export default SubsidyModel
